import { useQuery } from "@tanstack/react-query";
import { getFreshness } from "@/api/endpoints";
import { fmtET } from "@/lib/format";

// The backing probe currently queries MAX(CreatedDateTime) on PortalEvent.dbo.RequestDataAnalysis
// — i.e. the timestamp of the most-recent request the analytics DB has observed. That's a proxy
// for "how fresh is the data" but not a true Cosmos→SQL sync watermark. Label it honestly until a
// dedicated watermark table is available (PRD §Freshness).
export function FreshnessChip() {
  const { data, isError } = useQuery({
    queryKey: ["freshness"],
    queryFn: getFreshness,
    refetchInterval: 60_000,
  });

  if (isError || !data?.lastSyncUtc) {
    return <span className="freshness-chip muted">Activity unavailable</span>;
  }

  const minutes = Math.max(0, Math.round((data.ageSeconds ?? 0) / 60));
  const stale = data.status === "stale";
  const label =
    minutes < 1 ? "Most recent request: just now" : `Most recent request: ${minutes} min ago`;
  return (
    <span
      className={`freshness-chip ${stale ? "stale" : "healthy"}`}
      title={`Latest CreatedDateTime in PortalEvent: ${fmtET(data.lastSyncUtc)}`}
    >
      {label}
    </span>
  );
}
